import { render, staticRenderFns } from "./integration.vue?vue&type=template&id=dc2aba00&scoped=true&"
import script from "./integration.vue?vue&type=script&lang=js&"
export * from "./integration.vue?vue&type=script&lang=js&"
import style0 from "./integration.vue?vue&type=style&index=0&id=dc2aba00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2aba00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc2aba00')) {
      api.createRecord('dc2aba00', component.options)
    } else {
      api.reload('dc2aba00', component.options)
    }
    module.hot.accept("./integration.vue?vue&type=template&id=dc2aba00&scoped=true&", function () {
      api.rerender('dc2aba00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/pages/integration.vue"
export default component.exports